exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  height: 100%;\n  width: 100%; }\n\n.setup-cont {\n  margin-left: auto;\n  margin-right: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/check-setup/check-setup.component.scss
// module id = ../../../../../src/app/views/check-setup/check-setup.component.scss
// module chunks = main